
<div fieldmagicGridRow>
  <div fieldmagicGridColumn="12">
    <div class="row">
      <div class="col-6">
        <div class="d-flex justify-content-end w-100 h-100">
          <div class="w-100 border">
            <div class="card-header bg-primary text-white d-flex justify-content-center align-items-center">
              <span>{{ 'available_field' | translate }}</span>
            </div>

            <div
              cdkDropList
              #displayedList="cdkDropList"
              [cdkDropListData]="availableFields"
              [cdkDropListConnectedTo]="[hiddenList]"
              class="overflow-auto min-height-100 max-height-200"
              [cdkDropListDisabled]="disabled"
              (cdkDropListDropped)="drop($event)">

              <div *ngFor="let field of availableFields" class="m-2" cdkDrag [cdkDragDisabled]="disabled">
                <button class="btn field-button-list wrap-text w-100" cdkDragHandle [disabled]="disabled">
                  <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
                  <span class="ml-2">
                    {{ field.displayName || field.name | translate }}
                  </span>
                </button>
              </div>

              <div *ngIf="availableFields.length === 0" class="text-center text-muted p-3">
                {{ 'no_fields_available' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="d-flex justify-content-start w-100 h-100 mh-100">
          <div class="w-100 border">
            <div class="card-header bg-success text-white d-flex justify-content-center align-items-center">
              <span>{{ 'displayed_field' | translate }}</span>
            </div>

            <div
              cdkDropList
              #hiddenList="cdkDropList"
              [cdkDropListData]="displayedFields"
              [cdkDropListConnectedTo]="[displayedList]"
              class="overflow-auto min-height-100 max-height-200"
              [cdkDropListDisabled]="disabled"
              (cdkDropListDropped)="drop($event)">

              <div *ngFor="let field of displayedFields" class="m-2" cdkDrag [cdkDragDisabled]="disabled">
                <button class="btn field-button-list wrap-text w-100" cdkDragHandle [disabled]="disabled">
                  <fa-icon [icon]="['fas', 'arrows-alt']"></fa-icon>
                  <span class="ml-2">
                    {{ field.displayName || field.name | translate }}
                  </span>
                </button>
              </div>

              <div *ngIf="displayedFields.length === 0" class="text-center text-muted p-3">
                {{ 'no_fields_available' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
